export const environment = {
    production: true,
    basePath: '/portal/peindex',
    clientHost: 'https://globalmarkets.statestreet.com',
    serverHost: 'http://localhost:8080',
    apiHost: 'https://ssa.dpe0128-prd.prd.aws.c.statestr.com'
};
